var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-hide-email-opt-in.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<li class=\"c-form-adjacent__li\">\n    <input\n        type=\"checkbox\"\n        id=\"loyalty-create-email-subscription\"\n        class=\"c-form-adjacent__checkbox c-form-adjacent__checkbox--long-label u-off-screen-hidden\"\n        data-qa-email-subscription-checkbox\n        name=\"createEmailSubscription\"\n        ";
output += "\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loyaltyConfig")),"defaultEmailSignUpBoxToChecked") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"userLocation")),"isUS")) {
output += " checked ";
;
}
output += " />\n    <label for=\"loyalty-create-email-subscription\" class=\"c-form-adjacent__label\" data-qa-loyalty-email-subscription-label>\n        ";
output += runtime.suppressValue((lineno = 10, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-create_subscription_signup-verbiage-US"])), env.opts.autoescape);
output += "\n    </label>\n</li>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-hide-email-opt-in.j2"] , dependencies)